module.exports = __webpack_public_path__ + "static/media/logo-vodovod-split.63df9915.png";